import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { useValidators } from "../../../helpers/validation";
import { useCustomTranslation } from "../../../helpers/translateHelpers";
import SubmitButton from "../SubmitButton";
import TextInput from "../TextInput";
import PhoneInput from "../PhoneInput";
import { PhoneNumber } from "../../../common/models";

interface ContactPersonFormProps {
  onSubmit: (data: ContactPersonFormValues) => void;
}

export interface ContactPersonFormValues {
  firstName: string;
  lastName: string;
  position?: string | null;
  email: string;
  phone: PhoneNumber;
}

const ContactPersonForm = (props: ContactPersonFormProps) => {
  const { tInput } = useCustomTranslation();

  const methods = useForm<ContactPersonFormValues>({
    mode: "onBlur",
  });

  const validators = useValidators();

  const onSubmit: SubmitHandler<ContactPersonFormValues> = (data) =>
    props.onSubmit(data);

  const { handleSubmit } = methods;

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="grid grid-cols-2 gap-x-2">
          <TextInput
            name="firstName"
            required
            options={{
              required: validators.required,
              maxLength: validators.maxLength(50),
            }}
            placeholder={tInput("first_name_placeholder")}
          />
          <TextInput
            name="lastName"
            required
            options={{
              required: validators.required,
              maxLength: validators.maxLength(50),
            }}
            placeholder={tInput("last_name_placeholder")}
          />
          <PhoneInput
            name="phone"
            required
            placeholder={tInput("phone_placeholder")}
          />
          <TextInput
            name="email"
            type="email"
            required
            options={{
              required: validators.required,
              maxLength: validators.maxLength(50),
            }}
            placeholder={tInput("email_contact_placeholder")}
          />
          <TextInput
            name="position"
            options={{
              maxLength: validators.maxLength(50),
            }}
            placeholder={tInput("position_placeholder")}
          />
        </div>
        <SubmitButton
          className="mt-2"
          label={tInput("contact_person_add_button")}
        />
      </form>
    </FormProvider>
  );
};

export default ContactPersonForm;
